/* global process */

let orderAuditBase = window._env_.VUE_APP_ORDER_AUDIT_API_HOST

// 工单复核相关API
export const queryReviewTaskTableApi = params => {
  return axios.post(`${orderAuditBase}/admin/review-task/query`, params)
}
export const reviewAuditQualityApi = params => {
  return axios.post(`${orderAuditBase}/admin/review-task/review-quality/${params.id}`, params)
}
export const getReviewAuditQualityApi = params => {
  return axios.get(`${orderAuditBase}/admin/review-task/get-result/${params.id}`, {params})
}



// WEBPACK FOOTER //
// ./src/views/task/review-task.api.js